import DashboardLayout from "../../../../Layouts/DashboardLayout";
import ContentBodyWrapper from "../../../../Layouts/Containers/ContentBodyWrapper";
import ContentBodyHeader from "../../../../Layouts/Containers/ContentBodyHeader";
import CreatePermissionForm from "../../../../components/Forms/CreatePermissionForm";
import reactRouteList from "../../../../config/react-route-list-config";
import { useTranslation } from "react-i18next";
import { changeBrowserTabTitle } from "../../../../utils/Browser";
import ButtonBlack from "../../../../components/Buttons/ButtonBlack";
export default function PermissionCreatePage() {
    const [t] = useTranslation();
    changeBrowserTabTitle("Create Permission");
    const buttons = (
        <ButtonBlack
            to={reactRouteList.loggedRoutes.permission_list}
            icon={"material-symbols:arrow-back"}
        >
            {t("Back")}
        </ButtonBlack>
    );

    return (
        <>
            <DashboardLayout>
                <ContentBodyWrapper showFooter={true}>
                    <ContentBodyHeader
                        info={{
                            title: t("Create Permission"),
                        }}
                        breadcrumb={[
                            {
                                linkitem: t("Permissions"),
                                link: reactRouteList.loggedRoutes
                                    .permission_list,
                            },
                            {
                                linkitem: t("Create"),
                                link: reactRouteList.loggedRoutes
                                    .create_permissions,
                            },
                        ]}
                        buttons={buttons}
                    />
                    <CreatePermissionForm />
                </ContentBodyWrapper>
            </DashboardLayout>
        </>
    );
}
